import { userService } from "@/services";
import { router } from "@/router";

const user = JSON.parse(localStorage.getItem("user"));
const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null };

const defaultProfileImageUrl = require("@/assets/images/avatar.svg");

const actions = {
  login({ dispatch, commit }, { username, password, origin }) {
    commit("loginRequest", { username });

    userService.login(username, password, origin).then(
      (user) => {
        commit("loginSuccess", user);
        router.push("/");
      },
      (error) => {
        commit("loginFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  logout({ commit }) {
    userService.logout();
    commit("logout");
    commit("alert/reset", null, { root: true });
    commit("asset/reset", null, { root: true });
    commit("map/reset", null, { root: true });
    commit("navigation/reset", null, { root: true });
    router.replace("/login");
  },
};

const getters = {
  getDisplayName: (state) => {
    if (state.user && state.user.nickname) {
      return state.user.nickname;
    }
    if (state.user && state.user.firstName) {
      return state.user.firstName;
    }
    return "";
  },
  getDefaultProfileImageUrl: (state) => {
    return defaultProfileImageUrl;
  },
  getProfileImageUrl: (state) => {
    if (state.user && state.user.profileImageUrl) {
      return state.user.profileImageUrl;
    }
    return defaultProfileImageUrl;
  },
  getIsNewUser: (state) => {
    if (state.user) {
      const loginCount = state.user.loginCount;
      return loginCount && loginCount == 1;
    }
    return false;
  },
  getShowTour: (state) => {
    return state.user.showTour == undefined ? true : state.user.showTour;
  },
  getIsBusinessAccount: (state) => {
    if (state.user) {
      return state.user.subscriberType == "Business";
    }
    return false;
  },
};

const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    state.user = user;
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
  updateNickname(state, nickname) {
    state.user.nickname = nickname;
    localStorage.setItem("user", JSON.stringify(state.user));
  },
  updateProfileImageUrl(state, profileImageUrl) {
    state.user.profileImageUrl = profileImageUrl;
    localStorage.setItem("user", JSON.stringify(state.user));
  },
  updateAccountType(state, accountType) {
    state.user.accountType = accountType;
  },
  updateShowTour(state, value) {
    state.user.showTour = value;
    localStorage.setItem("user", JSON.stringify(state.user));
  },
};

export const account = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
